<template>
  <div id="login" class="login-form">
    <form @submit.prevent="login" action="@login" class="form-modal">
      <label for="email">Email</label>
      <input type="email" name="email" v-model="email">

      <label for="password">Password</label>
      <input type="password" name="password" v-model="password">
      <p class="feedback" v-if="feedback">{{feedback}}</p>
      <button :disabled="btnClicked" class="login-button">Let me in</button>
    </form>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
      btnClicked: null
    };
  },
  methods: {
    login() {
      
      if (this.email && this.password) {
        this.btnClicked = true;
        this.feedback = null;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(cred => {
            let user = cred.user;
            this.$router.push({ name: "weatherImport" });
            // console.log(user)
          })
          .catch(err => {
            this.feedback = err.message;
          });
      } else {
        this.feedback = "Please enter login and password";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.login-form {
  padding: 4px 25px;
}

.form-modal {
  & label {
    margin-right: 4px;
  }

  & input {
    margin-right: 22px;
    height: 16px;
    padding: 4px;
  }

  & .login-button {
    height: 28px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    padding: 5px 20px;
    background-color: #934f07;
    color: white;
    cursor: pointer
    opacity: 0.7;
    transition: 0.7s;
  }
  & .login-button:disabled {
    opacity: 0.1;
  }
}
</style>

